"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IFloodgateStorageProvider = require("./Api/IFloodgateStorageProvider");
var GovernedChannel_1 = require("./GovernedChannel");
var Utils = require("./Utils");
var GovernedChannelState = /** @class */ (function () {
    function GovernedChannelState(type, cooldownStartTime) {
        this.ChannelType = type;
        this.CooldownStartTimeUtc = cooldownStartTime;
        if (!this.validate()) {
            throw new Error("Constructor arguments are not valid");
        }
    }
    /**
     * Method to deserialize a JSON object to class object
     * @param input: JSON object
     * Returns class object
     */
    GovernedChannelState.deserialize = function (input) {
        var result;
        if (!input) {
            return null;
        }
        // Validation is handled by GovernedChannelState's constructor
        try {
            result = new GovernedChannelState(input.ChannelType, input.CooldownStartTimeUtc);
        }
        catch (e) {
            // TODO(gachoi) Log parsing failed
            return null;
        }
        return result;
    };
    GovernedChannelState.prototype.validate = function () {
        if (!Utils.isEnumValue(this.ChannelType, GovernedChannel_1.GovernedChannelType)) {
            return false;
        }
        // make it a date object if it's a valid UTC date time value
        if (Utils.isUtcDatetimeString(this.CooldownStartTimeUtc)) {
            this.CooldownStartTimeUtc = Utils.stringToDate(this.CooldownStartTimeUtc);
            // Allow null and bad cooldownStartTime
        }
        else if (Utils.isNullOrUndefined(this.CooldownStartTimeUtc) || !Utils.isDate(this.CooldownStartTimeUtc)) {
            this.CooldownStartTimeUtc = Utils.getDistantPast();
        }
        return true;
    };
    GovernedChannelState.prototype.getType = function () {
        return this.ChannelType;
    };
    GovernedChannelState.prototype.getCooldownStartTime = function () {
        return this.CooldownStartTimeUtc;
    };
    return GovernedChannelState;
}());
exports.GovernedChannelState = GovernedChannelState;
/**
 * Class representing what is stored in the file.
 */
var FileData = /** @class */ (function () {
    function FileData() {
    }
    return FileData;
}());
var FileBasedGovernedChannelStateProvider = /** @class */ (function () {
    function FileBasedGovernedChannelStateProvider(storage) {
        if (!storage) {
            throw new Error("storage must not be null");
        }
        this.storage = storage;
    }
    // @Override
    FileBasedGovernedChannelStateProvider.prototype.load = function () {
        // Load channel state from file using _storageProvider (get back string)
        var readString = this.storage.read(IFloodgateStorageProvider.FileType.GovernedChannelStates);
        if (!readString) {
            return [];
        }
        var fileData;
        try {
            fileData = JSON.parse(readString);
        }
        catch (e) {
            // TODO(gachoi) Log parsing failed
            return [];
        }
        var result = [];
        if (fileData && fileData.ChannelStates) {
            fileData.ChannelStates.forEach(function (state) {
                var newState = GovernedChannelState.deserialize(state);
                if (newState) {
                    result.push(newState);
                }
            });
        }
        return result;
    };
    // @Override
    FileBasedGovernedChannelStateProvider.prototype.save = function (states) {
        if (!states) {
            return;
        }
        var fileData = new FileData();
        fileData.ChannelStates = states;
        var writeString = JSON.stringify(fileData);
        this.storage.write(IFloodgateStorageProvider.FileType.GovernedChannelStates, writeString);
    };
    return FileBasedGovernedChannelStateProvider;
}());
exports.FileBasedGovernedChannelStateProvider = FileBasedGovernedChannelStateProvider;
